var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalenderAlt2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calender-alt-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.75 2.98125H14.2875V2.3625C14.2875 2.025 14.0063 1.71563 13.6406 1.71563C13.275 1.71563 12.9938 1.99688 12.9938 2.3625V2.98125H4.97815V2.3625C4.97815 2.025 4.6969 1.71563 4.33127 1.71563C3.96565 1.71563 3.6844 1.99688 3.6844 2.3625V2.98125H2.25002C1.29377 2.98125 0.478149 3.76875 0.478149 4.75313V14.5406C0.478149 15.4969 1.26565 16.3125 2.25002 16.3125H15.75C16.7063 16.3125 17.5219 15.525 17.5219 14.5406V4.725C17.5219 3.76875 16.7063 2.98125 15.75 2.98125ZM1.7719 8.2125H4.16252V10.9969H1.7719V8.2125ZM5.42815 8.2125H8.38127V10.9969H5.42815V8.2125ZM8.38127 12.2625V15.0188H5.42815V12.2625H8.38127ZM9.6469 12.2625H12.6V15.0188H9.6469V12.2625ZM9.6469 10.9969V8.2125H12.6V10.9969H9.6469ZM13.8375 8.2125H16.2281V10.9969H13.8375V8.2125ZM2.25002 4.24688H3.71252V4.8375C3.71252 5.175 3.99377 5.48438 4.3594 5.48438C4.72502 5.48438 5.00627 5.20313 5.00627 4.8375V4.24688H13.05V4.8375C13.05 5.175 13.3313 5.48438 13.6969 5.48438C14.0625 5.48438 14.3438 5.20313 14.3438 4.8375V4.24688H15.75C16.0313 4.24688 16.2563 4.47188 16.2563 4.75313V6.94688H1.7719V4.75313C1.7719 4.47188 1.96877 4.24688 2.25002 4.24688ZM1.7719 14.5125V12.2344H4.16252V14.9906H2.25002C1.96877 15.0188 1.7719 14.7938 1.7719 14.5125ZM15.75 15.0188H13.8375V12.2625H16.2281V14.5406C16.2563 14.7938 16.0313 15.0188 15.75 15.0188Z",
    fill: "#DEE4EE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderAlt2);
export default __webpack_public_path__ + "static/media/calender-alt-2.4cf2fc45a70fedf2d2aed49f7c997c96.svg";
export { ForwardRef as ReactComponent };